$(document).ready(function(){

	// -- Check id in url --
	checkIdInUrl();

	// -- Smooth Scroll --
	$('a[href^="#"], .scrollTop a').on('click', function(e){
		var id = $(this).attr("href");
		if (!id || id === '#') {
			return;
		}
		e.preventDefault();
		var shouldFocus = $(this).hasClass('skip-link');
		smoothScroll(id, { focus: shouldFocus });
		if (shouldFocus) {
			$(this).blur();
		}
	});


	function checkIdInUrl(){
		var url = window.location.href;
		if (url.indexOf('#') >= 0) {
			var id = '#' + url.split('#').pop();
			setTimeout(function(){
				smoothScroll(id);
				if ($(id).is('details')) {
					if ($('html').hasClass('no-details')){
						$(id).addClass('open').attr('open', true);
					} else {
						$(id).attr('open', true);
					}
				}
			},400);
		}
	}

	function smoothScroll(id, options){
		var $target = $(id);
		if (!$target.length) {
			return false;
		}
		options = options || {};
		var headerH = $('.header__navbar').outerHeight();
		$('html, body').animate({
			scrollTop: $target.offset().top - headerH - 15
		}, 'slow', function(){
			if (options.focus) {
				$target.attr('tabindex', '-1').focus();
			}
		});
		return false;
	}

});
